<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter" :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容：" label-for="key">
              <Input search enter-button placeholder="请输入设备编号/车辆编号搜索" clearable v-model="filter.search"
                     @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="同步时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段"
                          style="width: 100%" @on-ok="dateOk" @on-change="dateChange"
                          @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" style="flex-wrap: nowrap;justify-content: space-between;margin: 20px 20px 0 20px">
          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加作业记录</Button>
          </Col>
        </Row>
      </Form>

      <Table :columns="columns" stripe :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="info(row.id)">查看</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page"
            show-total @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import {agriculturalMachineryJobRecordsListApi} from '@/api/plant/agriculturalMachinery/agriculturalMachineryJobRecords'

export default {
  name: 'agriculturalMachineryJobRecordsList',
  data() {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        search: '',
        ctime: [],
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '车牌号',
          key: 'license_plate',
          minWidth: 120
        },
        {
          title: '设备编号',
          key: 'device_id',
          minWidth: 120
        },
        {
          title: '车辆编号',
          key: 'vehicle_id',
          minWidth: 120
        },
        {
          title: '作业类型',
          key: 'job_type_name',
          minWidth: 120
        },
        {
          title: '作业日期',
          key: 'job_date',
          minWidth: 150
        },
        {
          title: '作业开始时间',
          key: 'start_date',
          minWidth: 150
        },
        {
          title: '作业结束时间',
          key: 'end_date',
          minWidth: 150
        },
        {
          title: '地块编号',
          key: 'land_sn',
          minWidth: 120
        },
        {
          title: '深度点数',
          key: 'depth_point',
          minWidth: 120
        },
        {
          title: '行驶里程',
          key: 'drive_mileage',
          minWidth: 120
        },
        {
          title: '作业里程',
          key: 'job_mileage',
          minWidth: 120
        },
        {
          title: '作业地点经度',
          key: 'job_longitude',
          minWidth: 150
        },
        {
          title: '作业地点纬度',
          key: 'job_latitude',
          minWidth: 150
        },
        {
          title: '机具识别号',
          key: 'machine_sn',
          minWidth: 120
        },
        {
          title: '农具名称',
          key: 'tool_name',
          minWidth: 150
        },
        {
          title: '作业幅宽（毫米）',
          key: 'field_width',
          minWidth: 150
        },
        {
          title: '作业面积（亩）',
          key: 'job_area',
          minWidth: 120
        },
        {
          title: '作业合格面积（亩）',
          key: 'job_qualified_area',
          minWidth: 150
        },
        {
          title: '重叠面积（亩）',
          key: 'overlap_area',
          minWidth: 120
        },
        {
          title: '耕深（厘米）',
          key: 'depth',
          minWidth: 120
        },
        {
          title: '合格率 (%)',
          key: 'qualified_rate',
          minWidth: 120
        },
        {
          title: '作业地点-省',
          key: 'job_province',
          minWidth: 150
        },
        {
          title: '作业地点-市',
          key: 'job_city',
          minWidth: 150
        },
        {
          title: '作业地点-区县',
          key: 'job_county',
          minWidth: 150
        },
        {
          title: '作业地点-乡镇',
          key: 'job_town',
          minWidth: 150
        },
        {
          title: '作业地点-具体位置',
          key: 'job_position',
          minWidth: 200
        },
        {
          title: '油耗',
          key: 'oil_consumption',
          minWidth: 120
        },
        {
          title: '配药量',
          key: 'medicine_amount',
          minWidth: 120
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 200
        },
        {
          title: '同步时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created() {
    this.loadTableData()
  },
  methods: {
    loadTableData() {
      this.loading = true
      agriculturalMachineryJobRecordsListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage(status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear() {
      this.filter.page = 1
      this.filter.search = ''
      this.loadTableData()
    },
    // 选择时间
    dateOk() {
      this.filter.page = 1
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr) {
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear() {
      this.filter.ctime = []
      this.loadTableData()
    },

    // 同步
    add() {
      this.$router.push({path: this.pathFormat(this.$route.path, 'sync')})
    },

    // 详情
    info(id) {
      this.$router.push({path: this.pathFormat(this.$route.path, 'info', id)})
    },


  }
}
</script>
